export default __webpack_public_path__ + "static/media/Lamborgini.15660eab.png";